import { FC } from 'react';

import { useEventContext } from '../../hooks/contexts/event.context';
import SessionCard from '../SessionCard';
import * as Styles from './session-list.style';

const SessionList: FC = () => {
  const { dataCarousel } = useEventContext();

  return (
    <Styles.Container id="session-list-mb">
      {dataCarousel.map((item) => (
        <SessionCard key={item.id} {...item} />
      ))}
    </Styles.Container>
  );
};

export default SessionList;
